import axios from 'axios';

// const apiBaseUrl = 'https://backend-swagruhafoods.nbjfit.easypanel.host/'; // staging
const apiBaseUrl = 'https://backend.swagruhafoods.net/'; // production
const imageUrl="https://swagruha-foods-prod.s3.eu-north-1.amazonaws.com/"
const createAxiosInstance = (token) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json', // Ensure Content-Type is set here
    // Authorization: token ? `Bearer ${token}` : '',
  };

  return axios.create({
    baseURL: apiBaseUrl,
    headers,
  });
};

let instance = createAxiosInstance(localStorage.getItem('token'));

export const updateToken = (newToken) => {
  localStorage.setItem('token', newToken);
  instance = createAxiosInstance(newToken); 
};

export const uploadInstance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});


export const createPublicAxiosInstance = () => {
  return axios.create({
    baseURL: apiBaseUrl,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};

export const getInstance = () => {
  const token = localStorage.getItem('token');
  return createAxiosInstance(token);
};

instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['Content-Type'] = 'application/json'; 
    // console.log("Request Config:", config);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    // console.log("Response Data:", response.data); 
    return response;
  },
  error => {
    console.error("Response Error:", error.response);
    return Promise.reject(error);
  }
);

export { apiBaseUrl,imageUrl, instance as default };
